(function ($) {
    "use strict";
    $(function () {
        $(document).on("click", ".dropdown__title", function () {
            $(this).toggleClass("active");
            $(this).parent().find(".dropdown__inner").slideToggle("fast");
        });

        if ($(window).width() < 992) {
            $(document).on("click", ".detailed-filters>.dropdown>.dropdown-label", function () {
                const inner = $(this).parent().find(".radio-button-group").length ? $(this).parent().find(".radio-button-group") : $(this).parent().find(".checkbox-group");
                $(this).parent().toggleClass("open");
                inner.slideToggle("fast");
            });
        }
    });
})(jQuery);
